import { styled } from "@phntms/css-components";
import styles from "./styles.module.scss";
import { Link } from "@itchannelplus/navigation";

export const ExpandButtonContainer = styled("button", {
  css: styles.expandButton,
  variants: {
    expanded: {
      true: [styles.expanded],
    },
    small: {
      true: [styles.small],
    },
    color: {
      light: [styles.light],
      dark: [styles.dark],
      lime: [styles.lime],
    },
  },
});

export const ExpandLinkContainer = styled(Link, {
  css: styles.expandButton,
  variants: {
    expanded: {
      true: [styles.expanded],
    },
    small: {
      true: [styles.small],
    },
  },
});
export const ExpandIcon = styled("div", {
  css: styles.icon,
  variants: {},
});
